export default "__VITE_ASSET__CzvQP4K9__";